
export const getCookie = (name) => {
  let cookis = document.cookie.split(';').filter((item) => item)
  let cookieList = {}
  for (var i = 0; i < cookis.length; i++) {
    let cookieStr = cookis[i].split('=')
    cookieList[cookieStr[0].trim()] = cookieStr[1].trim()
  }
  return cookieList[name]
}

export const clearCookies = (name) => {
  if (name) {
    setCookie(name, '', -1)
  } else {
    let cookis = document.cookie.split(';').filter((item) => item)
    console.log('cookis', cookis)
    for (var i = 0; i < cookis.length; i++) {
      let cookieStr = cookis[i].split('=')
      setCookie(cookieStr[0].trim(), '', -1)
      setCookie(cookieStr[0].trim(), '', -1, '.vip.com')
    }
  }
}

export const setCookie = (cName, value, expireDate = 0, domain) => {
  const exDate = new Date()
  exDate.setTime(exDate.getTime() + expireDate)
  document.cookie = cName + '=' + window.decodeURIComponent(value) + (expireDate== null ? '' : ';expires=' + exDate.toUTCString()) + ';path=/;' + (domain ? ('domain=' + domain) : '')
}

